// Thin wrappers around window.location so tests can jest.mock this module
// instead of redefining window.location (which is non-configurable in JSDOM 22+).

export const setHref = (url) => {
  window.location.href = url;
};

export const getHref = () => window.location.href;

export const reload = () => {
  window.location.reload();
};

export const replace = (url) => {
  window.location.replace(url);
};

export const getSearch = () => window.location.search;

export const getPathname = () => window.location.pathname;

// Rewrite the current URL in place without a navigation or history entry.
// Used to strip the magic-link token from the address bar after redemption
// (SEC-08) so it cannot linger in history, access logs, or the Referer header.
export const replaceUrl = (url) => {
  if (window.history?.replaceState) {
    window.history.replaceState(null, '', url);
  }
};
